import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ListingStatusForm from '../../../components/forms/ListingStatusForm';
import { useListingStatusById, useUpdateListingStatus } from '../../../hooks/useListingStatusApi';
import { useNavigate, useParams } from 'react-router-dom';
import { ListingStatusDTO } from '../../../services/apiClient';

const ListingStatusEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data: entityData, isLoading } = useListingStatusById(id);
  const updateMutation = useUpdateListingStatus();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Listing Statuses', href: '/admin/listingstatuses' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await updateMutation.mutateAsync({ id: id!, data });
      navigate('/admin/listingstatuses');
    } catch (error) {
      console.error('Error updating ListingStatus:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/listingstatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.ListingStatus.Edit'
    >
        {entityData ? (
          <ListingStatusForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/listingstatuses')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default ListingStatusEdit;